class SearchWithOpenInput extends HTMLElement {
	constructor() {
		super();
		this.controller = null;
		this.signal = null;
		this.header = document.querySelector(".header-wrapper");
		this.searchInput = this.querySelector(".search__input");
		this.searchModal = this.querySelector(".search-with-open-input .search__modal");

		this.searchInputEventsHandler();
		this.searchInputHandler();
		this.addToCartHandler();
}

	searchInputEventsHandler() {
		this.searchInput.addEventListener('click', this.openModalHandler.bind(this))
	}

	openModalHandler() {
		if (!document.querySelector('body').classList.contains('overflow-hidden-drawer')) {
			document.querySelector("body").classList.add("overflow-hidden");
			document.querySelector(".shopify-section-header").classList.add("overlay");
		};

		if (this.searchInput.value.length > 0 ) return;

		const controller = new AbortController();
		const { signal } = controller;
		this.controller = controller;
		this.signal = signal;

		this.searchModal.classList.add('open-madal');
		document.querySelector('body').addEventListener('click', this.onBodyClick.bind(this), { signal });
	}

	addToCartHandler() {
		const allCardLinks = this.querySelectorAll('.card__link')
		allCardLinks.forEach(button => button.addEventListener('click', () => {
			this.searchModal && this.searchModal.classList.contains('open-madal') ? this.searchModal.classList.remove('open-madal') : null;
			document.querySelector(".shopify-section-header").classList.remove("overlay")
		}))
	}

	searchInputHandler() {
		this.searchInput.addEventListener('input', (event) => {
			if (event.target.value.length > 0) {
				this.searchModal.classList.remove('open-madal');
			} else this.searchModal.classList.add('open-madal');
		})
	}

	onBodyClick(event) {
		if (!this.contains(event.target)) this.close();
	}

	close() {
		document.querySelector(".shopify-section-header").classList.remove("overlay");
		this.searchModal && this.searchModal.classList.contains('open-madal') ? this.searchModal.classList.remove('open-madal') : null;
		document.querySelector("body").classList.contains("overflow-hidden") ? document.querySelector("body").classList.remove("overflow-hidden") : null;
		this.controller.abort();
	}
}

customElements.define("search-with-open-input", SearchWithOpenInput);
